if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.slideContainer = this.querySelector(
        "[data-swiper]:not([data-swiper-thumbs])"
      );
      this.video = false;
      if (this.dataset.swiperVideo) {
        this.video = true;
      }
      this.slides = this.querySelectorAll("[data-swiper-slide]");
      this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
      this.activeIndex = 0;
      this.initialized = false;
      this.resizeBound = false;
      if (this.dataset.swiperThumbs) {
        this.thumbnails = this.querySelector("[data-swiper-thumbs]");
      }
      this.boundInitializeSwiper = this.initializeSwiper.bind(this);
    }

    connectedCallback() {
      setTimeout(() => {
        if (this.dataset.customEvent) {
          this.attachCustomListeners(this.dataset.customEvent);
        }
        if (this.slideContainer && this.slides.length > 0) {
          this.initializeSwiper();
        } else {
          // ------------TD CHANGE-----------
          // Skip warning for deferred reinitialize flows where slides are injected later.
          if (this.dataset.customEvent !== "reinitialize") {
            console.warn("SwiperSlider - Slider or Slides Not Found");
          }
          // ----------END TD CHANGE---------
        }
      });
    }

    attachCustomListeners(customEvent) {
      switch (customEvent) {
        case "reinitialize":
          this.addEventListener(
            "reinitialize-swiper",
            this.boundInitializeSwiper
          );
          break;
      }
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
      if (this.dataset.customEvent) {
        switch (this.dataset.customEvent) {
          case "reinitialize":
            this.removeEventListener(
              "reinitialize-swiper",
              this.boundInitializeSwiper
            );
            break;
        }
      }
    }

    applyDefaultOptions(options) {
      if (options.loop === undefined) {
        options.loop = true;
      }
      if (options.speed === undefined) {
        options.speed = 400;
      }
      return options;
    }

    getSliderOptions() {
      try {
        return JSON.parse(this.dataset.swiperOptions);
      } catch (err) {
        console.log(err);
        return {};
      }
    }

    initializeSwiper() {
      if (window.Swiper && !this.initialized) {
        this.initialized = true;
        if (this.thumbnails) {
          this.setThumbnails();
        }
        if (this.video) {
          this.dispatchVideoEvent()
        }
        this.slider = new Swiper(this.slideContainer, this.sliderOptions);
        this.initializeSliderEventListeners();
      // ------------TD CHANGE-----------
      // Allow reinitialize-swiper to refresh dynamic slide sets on existing instances.
      } else if (window.Swiper && this.initialized && this.slider) {
        this.slider.update();
        this.slider.slideTo(0, 0);
      // ----------END TD CHANGE---------
      } else if (!window.Swiper) {
        console.warn("SwiperSlider - Swiper.js not found");
      }
      this.bindResizeEvent();
    }
    dispatchVideoEvent() {
      const swiperElm = this;
      this.sliderOptions.on = {
      	slideChange: function () {
          swiperElm.dispatchEvent(new CustomEvent("swiperSlideChanged", {detail: {slide_id: this.activeIndex}, bubbles: true}));
        }
      }
    }



    bindResizeEvent() {
      if (!this.resizeBound) {
        window.addEventListener("resize", this.handleResize.bind(this));
        this.resizeBound = true;
      }
    }

    handleResize(e) {
      if (this.slider) {
        setTimeout(() => {
          this.slider.updateSize();
        }, 300);
      }
    }

    setThumbnails() {
      const thumbsSlideContainer = this.thumbnails;
      const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
      const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
      this.sliderOptions.thumbs = { swiper: thumbnailsSlider };
      this.sliderOptions.on = {
        slideChange: function () {
          let activeIndex = this.activeIndex;
          document.dispatchEvent(
            new CustomEvent("thumbnail-changed", {
              detail: {
                slide: this.slides[this.activeIndex],
              },
            })
          );
          this.thumbs.swiper.slideTo(activeIndex > 0 ? activeIndex - 1 : 0);
        },
      };
    }

    initializeSliderEventListeners() {}
  }
  customElements.define("swiper-slider", SwiperSlider);
}
